export default __webpack_public_path__ + "static/media/endScroll.ae7b646a.png";